// @ts-nocheck
import { getStoreListShipTosDataView } from "@store/Framework/Store/Data/StoreListDetails/StoreListDetailsSelector";
import { StoreListCustomerModel, StoreListCustomersCollectionModel } from "@store/Framework/Types/ApiModels";
import { getStoreListCustomers, GetStoreListCustomersApiParameter } from "@store/Services/StoreListService";
import { ApiHandler, createHandlerChainRunner } from "@toolkit/Modules/client-framework/HandlerCreator";

type Props = {
    dataViewParameter: GetStoreListCustomersApiParameter;
    storelist?: StoreListCustomerModel[];
    apiResult?: StoreListCustomersCollectionModel;
    apiParameter: GetStoreListCustomersApiParameter;
};

type HandlerType = ApiHandler<GetStoreListCustomersApiParameter, StoreListCustomersCollectionModel, Props>;

export const DispatchBeginLoadStoreListCustomers: HandlerType = props => {
    props.dataViewParameter = props.getState().store.pages.storeListsDetails.customersParameter;
    props.storelist = getStoreListShipTosDataView(props.getState(), props.dataViewParameter).value;
    if (!props.storelist) {
        props.dispatch({
            type: "Data/StoreListDetails/BeginLoadStoreListCustomers",
            parameter: props.dataViewParameter,
        });
    }
};

export const PopulateApiParameter: HandlerType = props => {
    if (!props.storelist) {
        props.apiParameter = { ...props.dataViewParameter };
    }
};

export const RequestDataFromApi: HandlerType = async props => {
    if (!props.storelist) {
        props.apiResult = await getStoreListCustomers(props.apiParameter);
    }
};

export const DispatchCompleteLoadStoreListCustomers: HandlerType = props => {
    if (props.apiResult) {
        props.dispatch({
            type: "Data/StoreListDetails/CompleteLoadStoreListCustomers",
            result: props.apiResult,
            parameter: props.dataViewParameter,
        });
        props.dispatch({
            type: "Data/StoreLists/CompleteLoadStoreListCustomers",
            parameter: props.apiParameter,
            result: props.apiResult,
        });
    }
};

export const chain = [
    DispatchBeginLoadStoreListCustomers,
    PopulateApiParameter,
    RequestDataFromApi,
    DispatchCompleteLoadStoreListCustomers,
];

const loadStoreListCustomers = createHandlerChainRunner(chain, "LoadStoreListCustomers");
export default loadStoreListCustomers;
